/**
 * The BowlineWallet component
 */
import React from "react";
import { useSsrState, useSsrEffect } from "@issr/core";

import PropTypes from "prop-types";
import { ethers } from "ethers";
import { useAccount } from "../CustomHook";

/**
 * Stateless react component to render the BowlineWallet component
 * @param {Object} props the props passed to the component.
 */
const Balance = function () {
  const { ethProvider: provider, ethChainId: chainId } = useAccount();
  const { account, isEth, isSol, solanaConnection, solanaPublicKey } =
    useAccount();

  const [balance, setBalance] = useSsrState(0);
  useSsrEffect(async () => {
    if (isEth) {
      if (!!account && !!provider) {
        let stale = false;

        provider
          .getBalance(account)
          .then((balance) => {
            if (!stale) {
              setBalance(balance.toString());
            }
          })
          .catch(() => {
            if (!stale) {
              setBalance(null);
            }
          });

        return () => {
          stale = true;
          setBalance(undefined);
        };
      }
    } else if (isSol) {
      const lamports = await solanaConnection.getBalance(solanaPublicKey);
      console.log("lamports", lamports);
      setBalance(lamports / parseFloat(1e9).toFixed(2));
    }
  }, [account, provider, chainId]); // ensures refresh if referential identity of provider doesn't change across chainIds
  const displayBalance = !!balance ? balance : 0;
  const formattedBalance = isSol
    ? `SOL${displayBalance}`
    : `Ξ${ethers.utils.formatEther(displayBalance)}`;
  return (
    <>
      <span>
        {balance === null ? "Error" : balance ? formattedBalance : ""}
      </span>
    </>
  );
};

/**  define proptype for the 'translation' function  */
Balance.contextTypes = {
  t: PropTypes.func,
};

Balance.propTypes = {};

export default Balance;
